import { Mail, Phone } from 'lucide-react';
import Translate from '../shared/Translate';
import '../styles/welcome.css';

function Welcome( { isDomainRegistered, adminInfo, container } ) {
  let contactEmail = Translate.get('welcome.contactSupport.email');
  let contactPhone = Translate.get('welcome.contactSupport.phone');

  let title;
  if (!isDomainRegistered) {
    title = Translate.get('welcome.domainNotRegistered.title');
  } else if (!adminInfo.isAuthorized) {
    title = Translate.get('welcome.adminNotAuthorized.title');
  } else {
    title = Translate.get('welcome.unknownError.title');
  }

  let message;
  if (!isDomainRegistered) {
    message = Translate.get('welcome.domainNotRegistered.message');
  } else if (!adminInfo.isAuthorized) {
    message = Translate.get('welcome.adminNotAuthorized.message', null, { adminEmail: adminInfo.email });
  } else {
    message = Translate.get('welcome.unknownError.message');
  }

  const setLanguage = (language) => {
    Translate.setLanguage(language);
    container.tell({
      _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$UpdateLanguage',
      language: language
    })
  }

  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <div className="lang-switch">
          <button 
            className={Translate.language === 'en' ? 'active': ''}
            onClick={() => setLanguage('en')}
          >
            {Translate.get('language.en')}
          </button> |
          <button 
            className={Translate.language === 'cs' ? 'active': ''}
            onClick={() => setLanguage('cs')}
          >
            {Translate.get('language.cs')}
          </button>
        </div>
        <h1>
          {title}
        </h1>
        <p className='welcome-message'>
          {message}
        </p>
        <p>
          {Translate.get('welcome.contactSupport')}
        </p>
        <div className='welcome-row'>
          <p>{contactEmail}</p>
          <button className='welcome-button' onClick={() => window.open(`mailto:${contactEmail}`, '_self')}>
            <Mail />
            {Translate.get('welcome.contactSupport.email.button')}
          </button>
        </div>
        <div className='welcome-row'>
          <p>{contactPhone}</p>
          <button className='welcome-button' onClick={() => window.open(`tel:${contactPhone}`, '_self')}>
            <Phone />
            {Translate.get('welcome.contactSupport.phone.button')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Welcome;